import {routes} from './investigator.routes';
import InvestigatorListController from "./directory/directory.controller";
import InvestigatorService from "./investigator.service";
import InvestigatorDetailsController from "./details/details.controller";
import InvestigatorCreateInvestigatorController from "./new/new.controller";

export default angular.module('app.investigator', [])
  .config(routes)
  .controller('InvestigatorListController', InvestigatorListController)
  .service('InvestigatorService', InvestigatorService)
  .controller('InvestigatorDetailsController', InvestigatorDetailsController)
  .controller('InvestigatorCreateInvestigatorController', InvestigatorCreateInvestigatorController)
  .name;
